// When connecting to real backend, this mock will only be used for E2E tests
// The roles here should match test scenarios you want to cover
const e2eRoles = (process.env.NEXT_PUBLIC_E2E_ROLES || "dev-access").split(",").map(r => r.trim()).filter(Boolean);
const e2eGroups = (process.env.NEXT_PUBLIC_E2E_GROUPS || "").split(",").map(g => g.trim()).filter(Boolean);

export const mockAuthContext = {
  isReady: true,
  isAuthenticated: true,
  isLoading: false,
  user: {
    username: "test@e2e",
    name: "e2e-user",
    idToken: "test-id-token",
  },
  roles: e2eRoles,
  groups: e2eGroups,
  error: null,
  login: () => {},
  logout: () => {},
  getToken: async () => {
    return process.env.NEXT_PUBLIC_E2E_BEARER_TOKEN || "test-token";
  },
  hasRole: (requiredRoles: string[]) => {
    if (!requiredRoles || requiredRoles.length === 0) return true;
    return requiredRoles.some((role) => e2eRoles.includes(role));
  },
  hasGroup: (requiredGroups: string[]) => {
    if (!requiredGroups || requiredGroups.length === 0) return true;
    return requiredGroups.some((group) => e2eGroups.includes(group));
  },
};
